import { Component, Input, OnInit } from '@angular/core';
import { SurveyApiService } from '../survey-api.service';

@Component({
    selector: 'survey-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit {

@Input() getsurveyelement: any;
@Input() getrestaurantaddress:any;
@Input() commentcardStyles: any;
public descriptionHtml: any;


image :any;

  constructor(public surveyService: SurveyApiService) {

   }

  ngOnInit() {
   // console.log(this.getsurveyelement)
   // let data = sessionStorage.getItem('getsurveyelement');
   // console.log(data);
    this.surveyService.imagedata.subscribe((data) => {
      this.image = data;
    })

  }

  ngOnChanges() {
    let _input = this.getsurveyelement;
    if (_input) {
      // Plain string → Angular DomSanitizer runs on [innerHTML] (do not bypassSecurityTrustHtml)
      this.descriptionHtml = _input?.Payload?.FeedbackHeader ?? '';
    }
  }

}
